import React from 'react';
import { PlaceholderButton } from '../PlaceholderButton/PlaceholderButton';
import usePlaceholderButton from '../PlaceholderButton/usePlaceholderButton';

export interface AddSampleToCollectionTableButtonProps {
    children: React.ReactElement;
    isPlaceholderAllowed?: boolean;
}

export const AddSampleToCollectionTableButton: React.FC<
    AddSampleToCollectionTableButtonProps
> = ({ isPlaceholderAllowed = false, children }) => {
    const isPlaceholder = usePlaceholderButton({
        isPlaceholderAllowed,
        isActivated: false,
    });

    return isPlaceholder ? <PlaceholderButton /> : children;
};
